import api from '@/apis/di/commercialBankAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('commercialBank', api);
const state = {
    ...crud.state,
    _config: {
        table: 'di_bank',
        field: {
            key: 'bank_id',
            code: 'bank_code',
            name: 'bank_name',
            quickFollow: 'inactive',
        },
    },
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    debug: process.env.NODE_ENV !== 'production',
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
